export default __webpack_public_path__ + "static/media/config.c3c68bc3.svg";